import React from "react";

const AngelListComponent = () => {
  return (
    <div>
      <h2>AngelList</h2>
      <p>Explore remote job opportunities on AngelList:</p>
      <a href="https://angel.co/">AngelList - Remote Jobs</a>
      <p>
        AngelList is a platform primarily focused on startup jobs and
        investments. It features a range of startup job opportunities, including
        many that offer remote work or flexible arrangements. Job seekers can
        explore startup roles, such as engineering, marketing, design, and more,
        with various remote job options available. AngelList is an ideal
        platform for those interested in working for innovative startups that
        often provide remote work opportunities.
      </p>
    </div>
  );
};

export default AngelListComponent;
